import { api } from './api'
import { getLocale } from '@/i18n'
import type {
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  VerifyEmailRequest,
  ChangePasswordRequest,
  BecomeDeveloperResponse,
  User,
} from '@/types'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api'

export const authService = {
  async login(data: LoginRequest): Promise<LoginResponse> {
    return api.post<LoginResponse>('/auth/login', data)
  },

  async register(data: RegisterRequest): Promise<{ message: string }> {
    return api.post('/auth/register', data)
  },

  async verifyEmail(data: VerifyEmailRequest): Promise<LoginResponse> {
    return api.post<LoginResponse>('/auth/verify-email', data)
  },

  async forgotPassword(data: ForgotPasswordRequest): Promise<{ message: string }> {
    return api.post('/auth/forgot-password', data)
  },

  async resetPassword(data: ResetPasswordRequest): Promise<{ message: string }> {
    return api.post('/auth/reset-password', data)
  },

  async getMe(): Promise<User> {
    return api.get<User>('/me')
  },

  async changePassword(data: ChangePasswordRequest): Promise<void> {
    return api.put('/me/password', data)
  },

  async becomeDeveloper(): Promise<BecomeDeveloperResponse> {
    return api.post<BecomeDeveloperResponse>('/me/developer')
  },

  async resendVerification(): Promise<{ message: string }> {
    // The lang query pins the email language to the UI locale; the backend
    // would otherwise fall back to the browser Accept-Language header.
    return api.post(`/me/resend-verification?lang=${getLocale()}`)
  },

  getOAuthUrl(provider: 'github' | 'gitlab' | 'google' | 'discord'): string {
    return `${API_BASE_URL}/auth/oauth/${provider}`
  },
}
